import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  SalesDashboardContactsResponse,
  SalesDashboardQuery,
  SalesDashboardResponse,
} from './sales-dashboard.model';

// TVG-236: contact-centric Sales Dashboard data.
@Injectable({ providedIn: 'root' })
export class SalesDashboardService {
  private readonly url = `${environment.apiUrl}/api/sales-dashboard`;

  constructor(private http: HttpClient) {}

  getDashboard(query: SalesDashboardQuery): Observable<SalesDashboardResponse> {
    return this.http
      .get<{ data: SalesDashboardResponse }>(this.url, { params: this.buildParams(query) })
      .pipe(map((res) => res.data));
  }

  getContacts(
    query: SalesDashboardQuery,
    metric: string,
    stage: string | null,
    page: number,
    pageSize: number,
  ): Observable<SalesDashboardContactsResponse> {
    let params = this.buildParams(query)
      .set('metric', metric)
      .set('page', page.toString())
      .set('page_size', pageSize.toString());

    if (stage) {
      params = params.set('stage', stage);
    }

    return this.http.get<SalesDashboardContactsResponse>(`${this.url}/contacts`, { params });
  }

  private buildParams(query: SalesDashboardQuery): HttpParams {
    let params = new HttpParams()
      .set('from', query.from)
      .set('to', query.to)
      .set('group_by', query.groupBy);

    query.venueIds.forEach((id) => {
      params = params.append('venue_ids[]', id.toString());
    });
    query.staffIds.forEach((id) => {
      params = params.append('staff_ids[]', id.toString());
    });

    if (query.highValueThreshold !== null) {
      params = params.set('high_value_threshold', query.highValueThreshold.toString());
    }
    if (query.goingColdDays !== null) {
      params = params.set('going_cold_days', query.goingColdDays.toString());
    }

    return params;
  }
}
